import { badgeTemplateCoverageDTOSchema, badgeTemplateDTOSchema, effectiveBadgeTemplateDTOSchema, } from '@instanexus/contracts';
import { z } from 'zod';
import { dataEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const effectiveSchema = dataEnvelopeSchema(effectiveBadgeTemplateDTOSchema);
const templateSchema = dataEnvelopeSchema(badgeTemplateDTOSchema);
const coverageSchema = dataEnvelopeSchema(badgeTemplateCoverageDTOSchema);
const BADGE_TEMPLATES_PATH = `${WEB_API_PREFIX}/visitor/badge-templates`;
export function createBadgeTemplatesResource(transport) {
    return {
        async getEffective(query = {}) {
            const envelope = await transport.request({
                path: `${BADGE_TEMPLATES_PATH}/effective`,
                query,
                schema: effectiveSchema,
            });
            return envelope.data;
        },
        async upsert(input) {
            const envelope = await transport.request({
                method: 'PUT',
                path: BADGE_TEMPLATES_PATH,
                schema: templateSchema,
                body: input,
            });
            return envelope.data;
        },
        async remove(id) {
            await transport.request({
                method: 'DELETE',
                path: `${BADGE_TEMPLATES_PATH}/${encodeURIComponent(id)}`,
                schema: z.undefined(),
            });
        },
        async getCoverage(query = {}) {
            const envelope = await transport.request({
                path: `${BADGE_TEMPLATES_PATH}/coverage`,
                query,
                schema: coverageSchema,
            });
            return envelope.data;
        },
        async preview(query = {}) {
            const response = await transport.requestText({
                path: `${BADGE_TEMPLATES_PATH}/preview`,
                accept: 'image/svg+xml',
                query,
            });
            return response.body;
        },
        async previewDraft(input) {
            const response = await transport.requestText({
                method: 'POST',
                path: `${BADGE_TEMPLATES_PATH}/preview`,
                accept: 'image/svg+xml',
                body: input,
            });
            return response.body;
        },
    };
}
//# sourceMappingURL=badge-templates.js.map